import React, { useEffect, useMemo, useState } from "react";
import { Dropdown, Table } from "react-bootstrap";
import { Link, useHistory, useLocation } from "react-router-dom";
import AdminHeader from "../../../header/admin_header";
import AdminSidebar from "../../../sidebar/admin_sidebar";
import { AssessmentService } from "../../../../_services/admin/assessmentService";
import "../../../Sector_Question_Manage/control.css";
import AssessmentFilterBar, { MultiPickDropdown } from "./AssessmentFilterBar";
import {
  applyAssessmentFilters,
  buildLookupOptions,
} from "./assessmentFilters";
import { injectAssessmentChrome } from "./assessmentChrome";

/**
 * RIU-admin list of every assessment template (owner_type = RIU_TEMPLATE).
 *
 * Layout mirrors /reporting_module: AdminSidebar + AdminHeader chrome wrapping
 * a single `color_div_on` panel with the standard heading row, sticky-header
 * table, and icon-only Dropdown for row actions.
 */
const AssessmentTemplates = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    injectAssessmentChrome();
  }, []);

  const [rows, setRows] = useState([]);
  const [industryNames, setIndustryNames] = useState({});
  const [subIndustryNames, setSubIndustryNames] = useState({});
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState([]);
  const [industryFilter, setIndustryFilter] = useState([]);
  const [subIndustryFilter, setSubIndustryFilter] = useState([]);
  const [dateRange, setDateRange] = useState({ from: "", to: "" });

  const callList = async () => {
    const res = await AssessmentService.listAssessments({
      owner_type: "RIU_TEMPLATE",
      limit: 200,
    });
    if (res?.isSuccess) {
      setRows(res?.data?.data?.items ?? []);
    }
  };

  const loadIndustries = async () => {
    const res = await AssessmentService.listIndustries();
    const list = res?.data?.data ?? res?.data ?? [];
    if (!Array.isArray(list)) return;
    const indMap = {};
    const subMap = {};
    list.forEach((row) => {
      indMap[row.industry_type_id] = row.industry_type_name;
      (row.items || []).forEach((sub) => {
        subMap[sub.id] = sub.title;
      });
    });
    setIndustryNames(indMap);
    setSubIndustryNames(subMap);
  };

  useEffect(() => {
    callList();
    loadIndustries();
  }, []);

  const industryOptions = useMemo(
    () => buildLookupOptions(rows, "industry", industryNames),
    [rows, industryNames]
  );
  const subIndustryOptions = useMemo(
    () => buildLookupOptions(rows, "sub_industry", subIndustryNames),
    [rows, subIndustryNames]
  );

  const filtered = useMemo(
    () =>
      applyAssessmentFilters(rows, {
        search,
        statusFilter,
        statusField: "status_key",
        dateRange,
        dateField: "updated_at",
        lookups: [
          { values: industryFilter, field: "industry" },
          { values: subIndustryFilter, field: "sub_industry" },
        ],
      }),
    [rows, search, statusFilter, dateRange, industryFilter, subIndustryFilter]
  );

  return (
    <div>
      <AdminSidebar dataFromParent={location.pathname} />
      <AdminHeader />
      <div className="main_wrapper" style={{ display: "flex", flexDirection: "column" }}>
        <div className="inner_wraapper" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <div className="color_div_on framwork_2" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <div className="d-flex align-items-center justify-content-between">
                <div className="heading">
                  <h4 className="m-0">
                    <strong>Assessment Templates</strong>
                  </h4>
                  <div
                    onClick={() => history.push("/supplierassessment/create")}
                    className="mx-3 add_framework_control"
                  >
                    <i
                      className="fas fa-plus-square fs-lg"
                      title="Create Template"
                    ></i>
                    &nbsp;&nbsp;
                  </div>
                </div>
              </div>

              <div className="mt-3">
                <AssessmentFilterBar
                  rows={rows}
                  statusField="status_key"
                  search={search}
                  onSearchChange={setSearch}
                  searchPlaceholder="Search template…"
                  statusFilter={statusFilter}
                  onStatusFilterChange={setStatusFilter}
                  dateRange={dateRange}
                  onDateRangeChange={setDateRange}
                  dateLabel="Updated"
                  extraFilters={
                    <>
                      <MultiPickDropdown
                        options={industryOptions}
                        selected={industryFilter}
                        onChange={setIndustryFilter}
                        placeholder="Industry…"
                      />
                      <MultiPickDropdown
                        options={subIndustryOptions}
                        selected={subIndustryFilter}
                        onChange={setSubIndustryFilter}
                        placeholder="Sub-industry…"
                      />
                    </>
                  }
                />
              </div>

              <div className="supplier-mgmt-table-wrap mt-3" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                <div className="supplier-mgmt-table-scroll" style={{ flex: 1, overflowY: "auto" }}>
                <Table className="supplier-mgmt-table table mb-0">
                  <thead>
                    <tr>
                      <th style={{ width: 50 }}>Sr.</th>
                      <th>Title</th>
                      <th>Industry</th>
                      <th>Sub-industry</th>
                      <th style={{ width: 110 }}>Status</th>
                      <th style={{ width: 110 }}>Updated</th>
                      <th style={{ width: 50, textAlign: "center" }}>Action</th>
                    </tr>
                  </thead>
                  {filtered && filtered.length > 0 ? (
                    <tbody>
                      {filtered.map((a, idx) => (
                        <tr key={a.id}>
                          <td>{idx + 1}</td>
                          <td>
                            <Link to={`/supplierassessment/view/${a.id}`}>
                              {a.title}
                            </Link>
                          </td>
                          <td>{industryNames[a.industry] || a.industry}</td>
                          <td>
                            {subIndustryNames[a.sub_industry] ||
                              a.sub_industry}
                          </td>
                          <td>{a.status_key}</td>
                          <td>{a.updated_at?.slice(0, 10)}</td>
                          <td className="text-center">
                            <Dropdown>
                              <Dropdown.Toggle id={`dropdown-${a.id}`}></Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  onClick={() =>
                                    history.push(`/supplierassessment/view/${a.id}`)
                                  }
                                >
                                  <i className="fas fa-eye"></i>&nbsp;&nbsp; View
                                  Assessment
                                </Dropdown.Item>
                                {a.status_key === "DRAFT" && (
                                  <Dropdown.Item
                                    onClick={() =>
                                      history.push(
                                        `/supplierassessment/edit/${a.id}`
                                      )
                                    }
                                  >
                                    <i className="far fa-edit"></i>&nbsp;&nbsp;
                                    Edit Assessment
                                  </Dropdown.Item>
                                )}
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="7" className="text-center text-muted py-4">
                          {search || statusFilter.length || dateRange.from || dateRange.to
                            ? "No templates match the current filters"
                            : "No Data Found"}
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentTemplates;
